import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1da88dd4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "contact-column"
};
const _hoisted_2 = {
  key: 0,
  class: "contact-list"
};
const _hoisted_3 = {
  class: "contact-btn flex align-items"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "人力资源服务", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-service"
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contact-people"
}, [/*#__PURE__*/_createElementVNode("h3", null, "汪经理"), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-phone"
}), /*#__PURE__*/_createTextVNode(" 15956962129")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-mail"
}), /*#__PURE__*/_createTextVNode(" wlong@iwowke.com")])], -1));
const _hoisted_7 = {
  key: 1,
  class: "contact-list"
};
const _hoisted_8 = {
  class: "contact-btn flex align-items"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "职业教育服务", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-service"
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contact-people"
}, [/*#__PURE__*/_createElementVNode("h3", null, "武经理"), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-phone"
}), /*#__PURE__*/_createTextVNode(" 15375341343")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-mail"
}), /*#__PURE__*/_createTextVNode(" wjf@iwowke.com")])], -1));
const _hoisted_12 = {
  key: 2,
  class: "contact-list"
};
const _hoisted_13 = {
  class: "contact-btn flex align-items"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "继续教育服务", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-service"
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contact-people"
}, [/*#__PURE__*/_createElementVNode("h3", null, "孙经理"), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-phone"
}), /*#__PURE__*/_createTextVNode(" 18226636813")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-mail"
}), /*#__PURE__*/_createTextVNode(" sxy@iwowke.com")])], -1));
const _hoisted_17 = {
  key: 3,
  class: "contact-list"
};
const _hoisted_18 = {
  class: "contact-btn flex align-items"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "人力资源蓄水池", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-service"
}, null, -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contact-people"
}, [/*#__PURE__*/_createElementVNode("h3", null, "武经理"), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-phone"
}), /*#__PURE__*/_createTextVNode(" 15375341343")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-mail"
}), /*#__PURE__*/_createTextVNode(" wjf@iwowke.com")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_config_provider = _resolveComponent("van-config-provider");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.scenario == '' || $props.scenario == 'serviceHR' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_van_config_provider, {
    "theme-vars": $setup.themeVars
  }, {
    default: _withCtx(() => [_createVNode(_component_van_button, {
      type: "warning",
      round: "",
      size: "small",
      onClick: _cache[0] || (_cache[0] = $event => $options.phone('15956962129'))
    }, {
      default: _withCtx(() => [_hoisted_5, _createTextVNode("立即咨询")]),
      _: 1
    })]),
    _: 1
  }, 8, ["theme-vars"])]), _hoisted_6])) : _createCommentVNode("", true), $props.scenario == '' || $props.scenario == 'serviceVocation' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_van_config_provider, {
    "theme-vars": $setup.themeVars
  }, {
    default: _withCtx(() => [_createVNode(_component_van_button, {
      type: "warning",
      round: "",
      size: "small",
      onClick: _cache[1] || (_cache[1] = $event => $options.phone('15375341343'))
    }, {
      default: _withCtx(() => [_hoisted_10, _createTextVNode("立即咨询")]),
      _: 1
    })]),
    _: 1
  }, 8, ["theme-vars"])]), _hoisted_11])) : _createCommentVNode("", true), $props.scenario == '' || $props.scenario == 'serviceEdu' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_van_config_provider, {
    "theme-vars": $setup.themeVars
  }, {
    default: _withCtx(() => [_createVNode(_component_van_button, {
      type: "warning",
      round: "",
      size: "small",
      onClick: _cache[2] || (_cache[2] = $event => $options.phone('18226636813'))
    }, {
      default: _withCtx(() => [_hoisted_15, _createTextVNode("立即咨询")]),
      _: 1
    })]),
    _: 1
  }, 8, ["theme-vars"])]), _hoisted_16])) : _createCommentVNode("", true), $props.scenario == '' || $props.scenario == 'serviceXsc' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createVNode(_component_van_config_provider, {
    "theme-vars": $setup.themeVars
  }, {
    default: _withCtx(() => [_createVNode(_component_van_button, {
      type: "warning",
      round: "",
      size: "small",
      onClick: _cache[3] || (_cache[3] = $event => $options.phone('15375341343'))
    }, {
      default: _withCtx(() => [_hoisted_20, _createTextVNode("立即咨询")]),
      _: 1
    })]),
    _: 1
  }, 8, ["theme-vars"])]), _hoisted_21])) : _createCommentVNode("", true)]);
}